import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Apr 01 2019
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { AbstractRelease, CodebookLookupSequence, ReleaseType, ReleaseState } from '@logio/common-be-fe';
import { computed, observable, runInAction } from 'mobx';
import { codebookToSelectOption } from '../../../shared/utils';
import { CodeBookItemLayer } from '../../transportLayers/code-book/CodeBookItemLayer';
import { FormLayer } from '../../transportLayers/form/FormLayer';
import { ReleaseLayer } from '../../transportLayers/release/ReleaseLayer';
import { SiteReleaseLayer } from '../../transportLayers/release/SiteReleaseLayer';
import { BaseStore } from '../BaseStore';
/** Abstract release store */

export var AbstractReleaseStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(AbstractReleaseStore, _BaseStore);

  function AbstractReleaseStore() {
    var _this;

    _classCallCheck(this, AbstractReleaseStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractReleaseStore).apply(this, arguments));
    /** Layers used for REST communication  */

    _this.releaseLayer = new ReleaseLayer();
    _this.siteReleaseLayer = new SiteReleaseLayer();
    _this.codeBookItemLayer = new CodeBookItemLayer();
    _this.formLayer = new FormLayer();
    /** List of releases */

    _this.list = new Map();
    /** List of overviews */

    _this.overviews = new Map();
    _this.selloutStockValues = new Map();
    _this.previousImpacts = new Map();
    return _this;
  }

  _createClass(AbstractReleaseStore, [{
    key: "getAll",

    /**
     * Fetches releases
     * @param state - query parameter
     */
    value: function getAll(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.releaseLayer.findAll(params);

              case 3:
                list = _context.sent;
                runInAction(function () {
                  return _this2.list = list;
                });
                return _context.abrupt("return", list);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", this.handleCatchError(_context.t0, 'getAll'));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));
    }
  }, {
    key: "getSelloutStockValues",
    value: function getSelloutStockValues(releaseIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var selloutStockValues;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.releaseLayer.getSelloutStockValues(releaseIds);

              case 3:
                selloutStockValues = _context2.sent;
                runInAction(function () {
                  return _this3.selloutStockValues = selloutStockValues;
                });
                return _context2.abrupt("return", selloutStockValues);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", this.handleCatchError(_context2.t0, 'getSelloutStockValues'));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));
    }
  }, {
    key: "getPreviousImpacts",
    value: function getPreviousImpacts(releaseIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var previousImpacts;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.releaseLayer.getPreviousImpacts(releaseIds);

              case 3:
                previousImpacts = _context3.sent;
                runInAction(function () {
                  return _this4.previousImpacts = previousImpacts;
                });
                return _context3.abrupt("return", previousImpacts);

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", this.handleCatchError(_context3.t0, 'getPreviousImpacts'));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));
    }
    /**
     * Fetches release overviews - contains all necessary release info for release page.
     * @param params
     */

  }, {
    key: "getOverviews",
    value: function getOverviews(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this5 = this;

        var overviews;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.releaseLayer.findOverviews(params);

              case 3:
                overviews = _context4.sent;
                runInAction(function () {
                  return _this5.overviews = overviews;
                });
                return _context4.abrupt("return", overviews);

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", this.handleCatchError(_context4.t0, 'getOverviews'));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));
    }
    /**
     * Fetches releases depending on user roles ot other events specified on BE
     */

  }, {
    key: "getAllForDashBoard",
    value: function getAllForDashBoard() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.releaseLayer.findAllForDashboard();

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", this.handleCatchError(_context5.t0, 'getAllForDashboard'));

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 6]]);
      }));
    }
    /**
     * Affects Release with action from ReleaseAction enum
     * @param params - any
     * @return FIXME: docs
     */

  }, {
    key: "action",
    value: function action(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.releaseLayer.action(params);

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", this.handleCatchError(_context6.t0, 'action'));

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 6]]);
      }));
    }
    /**
     * Uploads prices to product
     * @param id - any
     * @param data {FormData} data file
     * @param onProgress allows handling of progress events for uploads
     * @return ProductPricesUpload
     */

  }, {
    key: "priceUpload",
    value: function priceUpload(id, data, onProgress) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return this.releaseLayer.priceUpload(id, data, onProgress);

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", this.handleCatchError(_context7.t0, 'priceUpload'));

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 6]]);
      }));
    }
  }, {
    key: "getUploadedPrice",
    value: function getUploadedPrice(id, uploadId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.releaseLayer.getUploadedPrice(id, uploadId);

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", this.handleCatchError(_context8.t0, 'priceUpload'));

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 6]]);
      }));
    }
    /**
     * Function finds select options for editing priceCodes
     * @param priceListType
     * @param releaseType
     * @returns array of price codes as FormElOption
     */

  }, {
    key: "getPriceCodeOptions",
    value: function getPriceCodeOptions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var priceCodeParams, lookup;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                priceCodeParams = {
                  priceListType: this.release.priceListType,
                  releaseType: this.release.releaseType
                };
                _context9.prev = 1;
                _context9.next = 4;
                return this.codeBookItemLayer.loadLookup(CodebookLookupSequence.PriceCode, priceCodeParams);

              case 4:
                lookup = _context9.sent;
                return _context9.abrupt("return", codebookToSelectOption(lookup.codeBooks));

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](1);
                return _context9.abrupt("return", this.handleCatchError(_context9.t0, 'priCodeOptions'));

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[1, 8]]);
      }));
    }
    /********************************************************************** Price Impact Report **************************************************************************/

    /**
     * Fletches abstract releases with impact report data depending on date Filter
     * @param params  date filter
     * @return Map of ReleaseTotalDTO or SelloutReleaseTotalDTO depending on store type
     */

  }, {
    key: "getPriceImpactReport",
    value: function getPriceImpactReport(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var _this6 = this;

        var list;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return this.releaseLayer.findPriceImpactReport(params);

              case 3:
                list = _context10.sent;
                runInAction(function () {
                  return _this6.list = list;
                });
                return _context10.abrupt("return", list);

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", this.handleCatchError(_context10.t0, 'getPriceImpactReport'));

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 8]]);
      }));
    }
  }, {
    key: "isSelloutSimulation",
    get: function get() {
      return this.release.releaseType === ReleaseType.Sellout && (this.release.state === ReleaseState.New || this.release.state === ReleaseState.Reopening) && !this.release.isUrgent();
    }
  }]);

  return AbstractReleaseStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", AbstractRelease)], AbstractReleaseStore.prototype, "release", void 0);

__decorate([observable, __metadata("design:type", Object)], AbstractReleaseStore.prototype, "list", void 0);

__decorate([observable, __metadata("design:type", Object)], AbstractReleaseStore.prototype, "overviews", void 0);

__decorate([observable, __metadata("design:type", Object)], AbstractReleaseStore.prototype, "selloutStockValues", void 0);

__decorate([observable, __metadata("design:type", Object)], AbstractReleaseStore.prototype, "previousImpacts", void 0);

__decorate([computed, __metadata("design:type", Boolean), __metadata("design:paramtypes", [])], AbstractReleaseStore.prototype, "isSelloutSimulation", null);